module.exports = __webpack_public_path__ + "static/img/logo_XP.b42b0a2a.png";